import { memo } from 'react';
import { useEditorSpotEditsModifications } from '../context/EditorSdkProvider';
import { useEditorTool } from '../hooks/useEditorTool';
import { SpotEditsManager } from '../ui/SpotEditsManager';

export const SpotEditsTool = memo(() => {
  const { isOpen, close } = useEditorTool('spotEditsManager');
  const { spotEditsModifications } = useEditorSpotEditsModifications();

  return (
    <SpotEditsManager
      isOpen={isOpen}
      onClose={close}
      spotEditsModifications={spotEditsModifications.map(
        ({ content }) => content
      )}
    />
  );
});

SpotEditsTool.displayName = 'SpotEditsTool';
